"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _useFieldContext = _interopRequireDefault(require("../../../../hooks/useFieldContext"));
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _utils = require("../../../../utils");
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
var _sv = _interopRequireDefault(require("../../../../sv.json"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var validationName = "ssn";
var regExpWithDash = /^(20|19)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))-\d{4}$/;
var regExpWithoutDash = /^(20|19)\d{2}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{4}$/;
var SSN = function SSN(props) {
  var _a, _b;
  var children = props.children,
    i18n = props.i18n,
    maxAge = props.maxAge,
    minAge = props.minAge,
    skipDash = props.skipDash,
    _c = props.type,
    type = _c === void 0 ? FSTypes.ValidationTypes.Error : _c,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var formI18n = (0, _useFormContext.default)().i18n;
  var _d = (0, _useFieldContext.default)(),
    addAdditionalInputProp = _d.addAdditionalInputProp,
    addValidation = _d.addValidation,
    label = _d.label,
    removeValidation = _d.removeValidation,
    fieldContextValidateOnChange = _d.validateOnChange;
  var validation = (0, _react.useCallback)(function (value, fieldName) {
    if (typeof value !== "string" || String(value).length === 0) {
      return [];
    }
    var textKeys = [];
    var additionalVariables = {};
    var regExp = skipDash ? regExpWithoutDash : regExpWithDash;
    if (regExp.test(String(value))) {
      var age = (0, _utils.getAgeFromSSN)(String(value));
      if (typeof age === "number") {
        if (minAge && age < minAge) {
          textKeys.push("textMinAge");
          additionalVariables = {
            age: age,
            minAge: minAge
          };
        }
        if (maxAge && age > maxAge) {
          textKeys.push("textMaxAge");
          additionalVariables = {
            age: age,
            maxAge: maxAge
          };
        }
      }
    } else if (skipDash && regExpWithDash.test(String(value))) {
      textKeys.push("textDash");
    } else {
      textKeys.push("text");
    }
    return textKeys.map(function (textKey) {
      var _a, _b, _c, _d;
      return {
        fieldName: fieldName,
        type: type,
        text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: children
        })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n[textKey]) || ((_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.ssn) === null || _c === void 0 ? void 0 : _c[textKey]) || ((_d = _sv.default.validation.field.ssn) === null || _d === void 0 ? void 0 : _d[textKey]), __assign(__assign({}, additionalVariables), {
          value: String(value),
          fieldName: fieldName,
          label: String(label)
        }))
      };
    });
  }, [children, (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.ssn, i18n, label, maxAge, minAge, skipDash, type]);
  (0, _react.useEffect)(function () {
    var regExp;
    if (skipDash) {
      regExp = /[^0-9]/g;
    } else {
      regExp = /[^0-9-]/g;
    }
    addAdditionalInputProp("filter", regExp);
    return function () {
      addAdditionalInputProp("filter", undefined);
    };
  }, [addAdditionalInputProp, skipDash]);
  (0, _react.useEffect)(function () {
    addValidation("".concat(validationName, "_").concat(uuid), validation, validateOnChange || fieldContextValidateOnChange);
    return function () {
      removeValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addValidation, fieldContextValidateOnChange, removeValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = SSN;
exports.default = _default;